import React from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import { CheckoutHistoryDetailType } from '../../controller/CheckoutController';
import moment from 'moment-timezone';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  item: CheckoutHistoryDetailType;
};

const test = [0, 1, 2, 3, 4];

const CheckoutDetailModal = ({ isVisible, setVisible, item }: Props) => {
  const onCloseModal = () => {
    setVisible(false);
  };

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: 'checkoutDetailModalOverlay',
        modal: 'checkoutDetailModal',
        root: 'customModalRoot',
      }}
      animationDuration={150}>
      <Style>
        <div className="modalWrapper">
          <div className="modalTitle">
            <div className="headerBar" />
            <h2>{'상세 보기'}</h2>
          </div>
          <div className="modalContent">
            <div className="row gap">
              <h3 className="title">{item.noticeTypeStr}</h3>
              <h3>{moment(new Date(item.sentDate)).format('HH:mm')}</h3>
              <h3>{moment(new Date(item.sentDate)).format('YYYY-MM-DD')}</h3>
            </div>
            <div className="contentBox">
              <div className="header">
                <h4>안내문구</h4>
              </div>
              <div className="content">
                <h4>{item.content}</h4>
              </div>
            </div>
            <div className="contentBox">
              <div className="header">
                <h4>객실</h4>
                {item.notCheckedNoticeAreaCount > 0 && (
                  <div className="badge">
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_close_red_box.svg`} alt="img" />
                    <h5>{`응답없는 객실 : ${item.notCheckedNoticeAreaCount}개`}</h5>
                  </div>
                )}
              </div>
              <div className="content">
                {item.noticeCheckedDataByAreaName.map((area, index) => (
                  <div key={index} className="row">
                    <h4 className="contentName">{area.areaName}</h4>
                    <div className="row gap room">
                      {area.noticeCheckedData.map((room, roomIndex) => (
                        <h4 key={roomIndex} className={`${room.noticeChecked ? '' : 'notCheck'}`}>
                          {room.name}
                          {roomIndex !== area.noticeCheckedData.length - 1 && ','}
                        </h4>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {item.checkoutTime && item.noticeBeforeMin > 0 && (
              <div className="contentBox">
                <div className="header">
                  <h4>알림시간</h4>
                </div>
                <div className="content">
                  <div className="row gap">
                    <h4>퇴실시간</h4>
                    <h4>{item.checkoutTime ? item.checkoutTime.slice(0, 5) : '즉시 알림'}</h4>
                  </div>
                  <div className="row gap">
                    <h4>알림시간</h4>
                    <h4>
                      {item.noticeBeforeMin > 0 ? `퇴실 ${item.noticeBeforeMin}분 전` : '즉시 알림'}
                    </h4>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="modalFooter">
            <button className="confirmButton" onClick={onCloseModal}>
              <h3>확인</h3>
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CheckoutDetailModal;

const Style = styled.div`
  li::marker {
    color: #4dd2ae;
  }

  .modalWrapper {
    overflow: scroll;
    text-align: left;
  }
  .modalTitle {
    .headerBar {
      width: 44px;
      height: 5px;
      margin: 0 auto;
      border-radius: 10px;
      background: #4dd2ae;
    }
    h2 {
      margin-top: 22px;
      font-size: 24px;
      font-weight: 500;
      color: #555;
      text-align: center;
    }
  }

  /* modalContent */
  .modalContent {
    padding: 8% 10%;
    .row.gap {
      gap: 10px;
      h3 {
        color: #979797;
      }
      h3.title {
        margin-right: 10px;
        color: #4dd2ae;
        font-weight: 600;
      }
    }

    .contentBox {
      margin: 14px 0;
      flex: 1;
      border: 1px solid #cecece;
      border-radius: 10px;
      .row.gap {
        padding: 4px 0;
        gap: 20px;
      }
      h4 {
        font-size: 16px;
        line-height: 24px;
      }

      .header {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 20px;
        background: #f7f7f7;
        border-bottom: 1px solid #cecece;
        border-radius: 10px 10px 0 0;
        h4 {
          font-weight: 600;
          color: #555555;
        }
      }
      .content {
        padding: 10px 20px;
        border-radius: 0 0 10px 10px;
        .row.gap.room {
          gap: 4px;
          flex-wrap: wrap;
        }
        h4 {
          font-weight: 400;
          color: #979797;
          white-space: pre-line;
        }
        h4.contentName {
          width: 60px;
        }
        h4.notCheck {
          color: #ff6060;
        }
      }
    }
  }

  .badge {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #ffebed;
    border-radius: 50px;
    padding: 4px 16px;

    h5 {
      font-weight: 600;
      line-height: 16px;
      color: #ff6060;
    }
  }

  .modalFooter {
    padding: 4% 10% 0 10%;
  }
  .confirmButton {
    margin: 0;
    width: 100%;
    padding: 12px 0;
    background: #4dd2ae;
    border: none;
    h3 {
      font-weight: 700;
    }
  }

  @media (max-width: 900px) {
    .modalWrapper {
      height: 100vh;
      height: 100dvh;
      background: #ffffff;
      padding: 40px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .modalTitle {
      .headerBar {
        display: none;
      }
      h2 {
        margin-top: 0;
        font-size: 20px;
      }
    }
    .modalContent {
      padding: 6%;
      .row.gap {
        gap: 8px;
        h3 {
          font-size: 18px;
        }
      }

      .contentBox {
        margin: 14px 0;
        .row.gap {
          padding: 2px 0;
          gap: 16px;
        }
        h4 {
          font-size: 14px;
          line-height: 22px;
        }
        .header {
          gap: 10px;
          padding: 6px 16px;
        }
        .content {
          padding: 6px 16px;
          h4.contentName {
            width: 36px;
          }
        }
      }
    }

    .badge {
      padding: 2px 10px;
      h5 {
        font-size: 12px;
      }
    }

    .modalFooter {
      padding: 4% 6% 0 6%;
    }
  }
`;
